export const MileageAnalysisLearnMore = 'learn_more_click'
